import styled from "styled-components";
import { FancyTitle } from "./components/fancyTitle";
import "react-image-gallery/styles/css/image-gallery.css";
import ImageGallery from "react-image-gallery";
import { useRef } from "react";
import { useNuovoRistoranteQuery } from "../../generated/graphql";
import { documentToReactComponents } from "@contentful/rich-text-react-renderer";

const Container = styled.div`
  display: flex;
  width: 100%;
  gap: 40px;
  padding-top: 100px;
  padding-bottom: 40px;

  z-index: 1;
  @media (max-width: 900px) {
    flex-direction: column;
    align-items: center;
    padding-top: 50px;
  }
  .image-gallery-content .image-gallery-slide .image-gallery-image {
    max-height: calc(80vh - 300px);
  }
`;

const TextDiv = styled.div`
  max-width: 400px;
  padding-left: 100px;
  @media (max-width: 900px) {
    padding: 0px 20px;
    p {
      text-align: justify;
    }
  }
`;
const ArrowContainer = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  padding-top: 20px;
  width: 100%;
  max-width: 500px;
  padding-right: 90px;
  @media (max-width: 900px) {
    padding: 20px 30px;
  }
`;
export const Arrow = styled.div`
  background-image: url("/kum/arrow.webp");
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  cursor: pointer;
  width: 50px;
  height: 50px;
`;
export const InvertedArrow = styled(Arrow)`
  transform: rotate(180deg);
`;
const GalleryDiv = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  align-items: center;
`;
export function Location() {
  const ref = useRef<ImageGallery>(null);

  const { data } = useNuovoRistoranteQuery();

  const images =
    data?.nuovoRistorante?.locationCollection?.items.map((val) => ({
      original: `https://padel-resort.netlify.app/.netlify/images?url=${val?.url}&fm=webp&w=800`,
      thumbnail: `https://padel-resort.netlify.app/.netlify/images?url=${val?.url}&fm=webp&w=800`,
    })) || [];
  function nextSlide() {
    const currentSlide = ref.current?.getCurrentIndex() || 0;
    if (ref.current) {
      ref.current.slideToIndex(currentSlide + 1);
    }
  }
  function prevSlide() {
    const currentSlide = ref.current?.getCurrentIndex() || 0;
    if (ref.current) {
      ref.current.slideToIndex(currentSlide - 1);
    }
  }
  return (
    <Container>
      <TextDiv>
        <FancyTitle text={data?.nuovoRistorante?.locationTitolo || ""} />
        <p>
          {documentToReactComponents(
            data?.nuovoRistorante?.locationTesto?.json
          )}
        </p>
      </TextDiv>
      <GalleryDiv>
        <ImageGallery
          items={images}
          showThumbnails={false}
          showFullscreenButton={false}
          showNav={false}
          infinite={true}
          slideDuration={600}
          showPlayButton={false}
          useTranslate3D
          ref={ref}
          lazyLoad={false}
        />
        <ArrowContainer>
          <Arrow onClick={prevSlide} />
          <InvertedArrow onClick={nextSlide} />
        </ArrowContainer>
      </GalleryDiv>
    </Container>
  );
}
